import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { makeStyles } from "@material-ui/core/styles";
import ThresholdInputBox from "../ThresholdInputBox";
import { getFormatedDate, formatToKOrM } from "../../../../helper";
import HorizontalBarChart from "../HorizontalBarChart";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';


const useStyles = makeStyles({
    tableWrapper: {
        overflowY: "auto",
        height: "450px", /* Adjust based on how much content you want visible before scrolling */
    },
    table: {
        width: "100%",
        borderCollapse: "collapse",
        fontFamily: "'Arial', sans-serif",
        margin: "20px 0",

    },
    header: {
        position: "sticky",
        top: "0",
        zIndex: "1",
    },
    th: {
        background: "#f7f9fc",
        padding: "10px",
        textAlign: "left",
        fontSize: "14px",
        fontWeight: "bold",
        borderBottom: "1px solid #ddd",
    },
    td: {
        padding: "10px",
        fontSize: "14px",
        borderBottom: "1px solid #ddd",
    },
    editableInput: {
        width: "70px",
        textAlign: "center",
        border: "0.5px solid #0082CA",
        borderRadius: "4px",
        padding: "2px 5px",
        color: "#929497",
        '&::-webkit-outer-spin-button': {
            WebkitAppearance: 'none',
            margin: 0,
        },
        '&::-webkit-inner-spin-button': {
            WebkitAppearance: 'none',
            margin: 0,
        },
        '&[type="number"]': {
            MozAppearance: 'textfield', // For Firefox
            MsAppearance: 'textfield',  // For IE/Edge
        },
    },
    chartContainer: {
        display: "flex",
        alignItems: "center",
    },
    chartBar: {
        height: "20px",
        borderRadius: "0px",
        marginRight: "0px",
    },
    chartBarWithBorder: {
        height: "20px",
        borderTopRightRadius: "30px", /* Apply border-radius to the top-right corner */
        borderBottomRightRadius: "30px", /* Apply border-radius to the bottom-right corner */
        marginRight: "0px",
    },
    nestle: { backgroundColor: "#FFD700", width: "40%" },
    baking: { backgroundColor: "#FF6347", width: "20%" },
    infant: { backgroundColor: "#FF69B4", width: "20%" },
    others: { backgroundColor: "#9370DB", width: "20%" },
    label: {
        fontSize: "12px",
        margin: "0 5px",
        color: "#555",
    },
    label_Bold: {
        fontWeight: 'bold'
    },
    withDot: {
        position: 'relative',
    },
    dot: {
        width: 8,
        height: 8,
        borderRadius: '50%',
        marginRight: 8, // Space between dot and label
        display: 'inline-block',
    },
    redDot: {
        backgroundColor: '#FFD700',
    },
    blueDot: {
        backgroundColor: '#FF6347',
    },
    greenDot: {
        backgroundColor: '#FF69B4',
    },
    purpleDot: {
        backgroundColor: '#9370DB',
    },
    closeButton: {
        border: "none",
        background: "#ffffff",
        fontSize: "18px",
        fontWeight: "700",
        cursor: "pointer"
    },
    percentageSign: {
        position: "absolute",
        right: "5px",
        top: "50%",
        transform: "translateY(-50%)",
        pointereEvents: "none", /* Prevents the percentage sign from interfering with input focus */
        fontSize: "16px",
        color: "#929497",
    },
    inputWrapper: {
        position: "relative",
        display: "inline-flex",
        alignItems: "center"
    },
});


const TableRowData = ({
    graphData,
    showDcData,
    filterdGraphData,
    entityName,
    showByPercentage,
    entityAndThreshold,
    setEntityAndThreshold,
    handleShowDC,
    handleRowClick,
    handleCloseGraph
}) => {

    const classes = useStyles();
    const networkOptions = ["AMBIENT", "CHILLED", "FROZEN", "NPW"];

    return(
            filterdGraphData?.length > 0 && filterdGraphData[0]?.hasOwnProperty("1_Division")
                && filterdGraphData?.map((row, index) => (
                    <tr key={index}>
                        <td>
                            {networkOptions?.includes(row.Entity_name) &&
                                // <button
                                // onClick={()=>handleShowDC(row)}
                                // >+</button>
                                <div style={{ cursor: "pointer", marginTop: "5px", marginLeft: "5px"}}>
                                    {!showDcData ?
                                        <AddCircleIcon 
                                        style={{ color: "rgb(0, 103, 161)" }}
                                        onClick={()=>handleShowDC(row)} />
                                        :
                                        <RemoveCircleIcon 
                                        style={{ color: "rgb(0, 103, 161)" }}
                                        onClick={()=>handleShowDC(row)} />
                                    }
                                </div>
                            }
                        </td>
                        <td
                            className={classes.td}
                            style={{ color: '#0067a1', fontWeight: 'bold' }}
                        >{row?.Entity_name}
                        </td>
                        <td className={classes.td}>
                            <ThresholdInputBox
                                index={index}
                                row={row}
                                graphData={graphData}
                                entityAndThreshold={entityAndThreshold}
                                setEntityAndThreshold={setEntityAndThreshold}
                            />
                        </td>
                        <td className={classes.td}>{row?.breach_start_date === "NA" ? "NA" : getFormatedDate(row?.breach_start_date)}</td>
                        <td className={classes.td}>{row?.breach_end_date === "NA" ? "NA" : getFormatedDate(row?.breach_end_date)}</td>
                        <td className={classes.td}>
                            <div className={classes.chartContainer} style={{ justifyContent: "space-evenly" }}>
                                <div>Avg</div>
                                <div>Max</div>
                            </div>
                            <div style={{ justifyContent: "space-evenly", display: "flex" }}>
                                <div className={classes.label_Bold} style={{ marginRight: '15px' }}>{row?.avg_percent_utilized === "NA" ? "NA" : (row?.avg_percent_utilized + "%")}</div>
                                <div className={classes.label_Bold}>{row?.max_percent_utilized === "NA" ? "NA" : (row?.max_percent_utilized + "%")}</div>
                            </div>
                        </td>
                        <td className={classes.td}>
                            <div className={classes.chartContainer} style={{ justifyContent: "space-evenly" }}>
                                <div>Avg</div>
                                <div>Max</div>
                            </div>
                            <div style={{ justifyContent: "space-evenly", display: "flex" }}>
                                <div className={classes.label_Bold} style={{ marginRight: '15px' }}>{row?.avg_pallets === "NA" ? "NA" : formatToKOrM(Number(row?.avg_pallets))}</div>
                                <div className={classes.label_Bold}>{row?.max_pallets === "NA" ? "NA" : formatToKOrM(Number(row?.max_pallets))}</div>
                            </div>
                        </td>
                        <td className={classes.td}>
                            {row?.hasOwnProperty("1_Division") && row["1_Division"] !== "NA" ?
                                <div style={{ minWidth: '24vw', maxWidth:'24vw' }}>
                                    <HorizontalBarChart
                                        item={row}
                                        showByPercentage={showByPercentage} />
                                </div>
                                :
                                <div style={{textAlign: "center"}}>
                                    NA
                                </div>
                            
                            }


                        </td>
                        <td className={classes.td}>
                            <div style={{ cursor: "pointer" }}>
                                {!entityName ?
                                    <ExpandMoreIcon
                                        onClick={() => handleRowClick(row)} />
                                    :
                                    <ExpandLessIcon
                                        onClick={handleCloseGraph} />
                                }
                            </div>
                        </td>
                    </tr>
                ))
    );
};


export default TableRowData;